import React, { useState } from 'react';
import { Search, Users } from 'lucide-react';
import './NonTeachingStaffList.css';

const NonTeachingStaffList = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);

  const staffData = [
    { sNo: 1, name: "Mr.A.K Pandey", post: "Adm.Officer" },
    { sNo: 2, name: "Mr.Raghvendra Saxena", post: "O.I" },
    { sNo: 3, name: "Mr.Dharmender Sihag", post: "LDC" },
    { sNo: 4, name: "Mr.Lovish Kumar", post: "LDC" },
    { sNo: 5, name: "Mr.Jai Prakash", post: "LDC" },
    { sNo: 6, name: "Mr.Vikas Laroiya", post: "LDC" },
    { sNo: 7, name: "Mr.Vikas Meel", post: "LDC" },
    { sNo: 8, name: "Miss Rooble Jassal", post: "Receptionist" },
    { sNo: 9, name: "Praveen", post: "ADM.Coordinator" },
    { sNo: 10, name: "Mr.Mahesh Godara", post: "Librarian" },
    { sNo: 11, name: "Mr.Rishabh Dev Goad", post: "Lab Asst" },
    { sNo: 12, name: "Mr.Arun", post: "Comp. Lab." },
    { sNo: 13, name: "Mr.Amandeep Singh", post: "supervisor" },
    { sNo: 14, name: "Mr.Ram Prakash", post: "Electr. Mech." },
    { sNo: 15, name: "Ms.Sarita", post: "CLASS IV" },
    { sNo: 16, name: "Ms.Pinki", post: "CLASS IV" },
    { sNo: 17, name: "Ms.Raju Devi", post: "CLASS IV" },
    { sNo: 18, name: "Ms.Sushila", post: "CLASS IV" },
    { sNo: 19, name: "Ms.Meena", post: "CLASS IV" },
    { sNo: 20, name: "Ms.Sunita Devi", post: "CLASS IV" },
    { sNo: 21, name: "Ms.Amarjit Kaur", post: "CLASS IV" },
    { sNo: 22, name: "Ms.Raj Bala", post: "CLASS IV" },
    { sNo: 23, name: "Ms.Sarika", post: "CLASS IV" },
    { sNo: 24, name: "Ms.Jyoti", post: "CLASS IV" },
    { sNo: 25, name: "Mr.Pawan Kumar", post: "IV Class" },
    { sNo: 26, name: "Mr.Rajesh Kumar", post: "IV Class" },
    { sNo: 27, name: "Mr.Vinod Kumar", post: "IV Class" },
    { sNo: 28, name: "Mr.Shyam Bahadur", post: "IV Class" },
    { sNo: 29, name: "Mr.Khem Bhadur", post: "IV Class" },
    { sNo: 30, name: "Mr.Rakesh Kumar", post: "IV Class" },
    { sNo: 31, name: "Mr.Sunil Jindal", post: "IV Class" },
    { sNo: 32, name: "Mr.Anil Kumar", post: "IV Class" },
    { sNo: 33, name: "Mr.Shyam Sunder", post: "IV Class" },
    { sNo: 34, name: "Mr.Ramdev", post: "Gardener" },
    { sNo: 35, name: "Mr.Jaychandra Ptel", post: "Gardener" },
    { sNo: 36, name: "Mr.Manohar Lal", post: "Gardener" },
    { sNo: 37, name: "Mr.Chander Pal", post: "Gardener" },
    { sNo: 38, name: "Mr.Dharamraj", post: "WatchMan" },
    { sNo: 39, name: "Mr.Jitendra Kumar", post: "WatchMan" },
    { sNo: 40, name: "Mr.Deen Bahadur", post: "WatchMan" },
    { sNo: 41, name: "Mr.Budhan Yadav", post: "WatchMan" },
    { sNo: 42, name: "Mr.Jagsir Singh", post: "Driver" },
    { sNo: 43, name: "Mr.Sunil Kumar", post: "Driver" },
    { sNo: 44, name: "Mr.Kuldeep Singh", post: "Driver" },
    { sNo: 45, name: "Mr.Yogesh Dagla", post: "Driver" },
    { sNo: 46, name: "Ms.Asha", post: "Sweeper" },
    { sNo: 47, name: "Mrs.Mamta", post: "Sweeper" },
    { sNo: 48, name: "Mr.Puneet Kumar", post: "Sweeper" },
    { sNo: 49, name: "Mr.Kishan Soni", post: "Sweeper" },
    { sNo: 50, name: "Mr.Veer (Dauly Wagee)", post: "Sweeper" }
  ];

  const filteredStaff = staffData.filter(staff =>
    staff.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
    staff.post.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const totalPages = Math.ceil(filteredStaff.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const currentStaff = filteredStaff.slice(startIndex, endIndex);

  const handleItemsPerPageChange = (e) => {
    setItemsPerPage(Number(e.target.value));
    setCurrentPage(1);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const getPageNumbers = () => {
    const pages = [];
    const maxVisible = 5;
    
    if (totalPages <= maxVisible) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      if (currentPage <= 3) {
        for (let i = 1; i <= 4; i++) pages.push(i);
        pages.push('...');
        pages.push(totalPages);
      } else if (currentPage >= totalPages - 2) {
        pages.push(1);
        pages.push('...');
        for (let i = totalPages - 3; i <= totalPages; i++) pages.push(i);
      } else {
        pages.push(1);
        pages.push('...');
        pages.push(currentPage - 1);
        pages.push(currentPage);
        pages.push(currentPage + 1);
        pages.push('...');
        pages.push(totalPages);
      }
    }
    return pages;
  };

  const getPostClass = (post) => {
    if (post.includes('Officer') || post.includes('O.I')) return 'badge-officer';
    if (post.includes('LDC') || post.includes('Receptionist')) return 'badge-ldc';
    if (post.includes('Librarian') || post.includes('Lab') || post.includes('Comp')) return 'badge-lab';
    if (post.includes('CLASS IV') || post.includes('IV Class')) return 'badge-class4';
    if (post.includes('Gardener')) return 'badge-gardener';
    if (post.includes('WatchMan')) return 'badge-watchman';
    if (post.includes('Driver')) return 'badge-driver';
    if (post.includes('Sweeper')) return 'badge-sweeper';
    return 'badge-other';
  };

  return (
    <div className="staff-container">
     {/* Banner Section with Background Image */}
      <section className="inner-bannerlib">
        <div className="banner-container">
          <h1>Admin Staff</h1>
        </div>
      </section>

      {/* Breadcrumb */}
      <section className="breadcrumb-section">
        <div className="breadcrumb-container">
          <ul className="breadcrumb-list">
            <li><a href="/">Home</a></li>
            <li>/</li>
            <li>Admin Staff</li>
          </ul>
        </div>
      </section>

      <div className="main-content">
        {/* Search Bar */}
        <div className="search-container">
          <div className="search-wrapper">
            <Search className="search-icon" size={20} />
            <input
              type="text"
              placeholder="Search by name or designation..."
              className="search-input"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
        </div>

        {/* Items per page selector */}
        <div className="items-selector">
          <div className="selector-left">
            <label className="selector-label">Show:</label>
            <select
              value={itemsPerPage}
              onChange={handleItemsPerPageChange}
              className="selector-dropdown"
            >
              <option value={10}>10</option>
              <option value={20}>20</option>
              <option value={30}>30</option>
              <option value={50}>50</option>
              <option value={staffData.length}>All</option>
            </select>
            <span className="selector-text">entries</span>
          </div>
          <div className="selector-info">
            Showing {startIndex + 1} to {Math.min(endIndex, filteredStaff.length)} of {filteredStaff.length} entries
          </div>
        </div>

        {/* Staff Table */}
        <div className="table-container">
          <div className="table-wrapper">
            <table className="staff-table">
              <thead>
                <tr className="table-header-row">
                  <th className="table-header">S. No.</th>
                  <th className="table-header">Name of Employee</th>
                  <th className="table-header">Post</th>
                </tr>
              </thead>
              <tbody className="table-body">
                {currentStaff.map((staff) => (
                  <tr key={staff.sNo} className="table-row">
                    <td className="table-cell cell-number">{staff.sNo}</td>
                    <td className="table-cell cell-name">{staff.name}</td>
                    <td className="table-cell">
                      <span className={`badge ${getPostClass(staff.post)}`}>
                        {staff.post}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          
          {currentStaff.length === 0 && (
            <div className="no-results">
              <p>No staff members found matching your search.</p>
            </div>
          )}
        </div>

        {/* Pagination */}
        {totalPages > 1 && (
          <div className="pagination">
            <button
              onClick={() => handlePageChange(currentPage - 1)}
              disabled={currentPage === 1}
              className="pagination-btn"
            >
              Previous
            </button>
            
            {getPageNumbers().map((page, index) => (
              page === '...' ? (
                <span key={`ellipsis-${index}`} className="pagination-ellipsis">...</span>
              ) : (
                <button
                  key={page}
                  onClick={() => handlePageChange(page)}
                  className={`pagination-btn ${currentPage === page ? 'pagination-active' : ''}`}
                >
                  {page}
                </button>
              )
            ))}
            
            <button
              onClick={() => handlePageChange(currentPage + 1)}
              disabled={currentPage === totalPages}
              className="pagination-btn"
            >
              Next
            </button>
          </div>
        )}

        {/* Footer */}
        <div className="footer">
          <p>Page {currentPage} of {totalPages}</p>
        </div>
      </div>
    </div>
  );
};

export default NonTeachingStaffList;